export default __webpack_public_path__ + "static/media/download.89e408bd.svg";